"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Chip = void 0;
var Chip_1 = require("./Chip");
Object.defineProperty(exports, "Chip", { enumerable: true, get: function () { return __importDefault(Chip_1).default; } });
//# sourceMappingURL=index.js.map